import { Component, OnInit } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { DerivativeSrcPrdService } from 'src/app/onelog/services/derivative-src-prd.service';
import {
  PAGE_SIZE,
  MAX_SIZE,
  CURRENCY_SYB,
} from 'src/app/onelog/common/config/common';
import { environment } from 'src/environments/environment';
import { DERIVATIVE_SOURCE_PRODUCT } from 'src/app/onelog/common/config/url';

@Component({
  selector: 'app-derivative-source-product',
  templateUrl: './derivative-source-product.component.html',
  styleUrls: ['./derivative-source-product.component.css'],
})
export class DerivativeSourceProductComponent implements OnInit {
  constructor(
    private _requestService: RequestService,
    private derivativeProduct: DerivativeSrcPrdService
  ) {}

  ngOnInit(): void {
    //this.getData();
    this.loadProducts(this.createPostData());
  }

  apiURL = environment.sachWebURL;
  selectedproductId: string = '';
  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 0;
  showSearchLoading: boolean = false;
  pageSize: number = PAGE_SIZE;
  maxSize: number = MAX_SIZE;
  Currency: any = CURRENCY_SYB;
  searchBtnText: string = 'Search';
  selectedStatusFilterType: string = '';
  responseData: any = [];

  // getData(){
  //   //this.setSearching();
  //   this._requestService.getRequest('/derivative_source_product').subscribe((data:any)=>{
  //     console.log(data);
  //     this.products = data.data;
  //     this.totalProducts = data.total;
  //     this.perPage = data.per_page;
  //     this.lastPage = data.last_page;
  //     this.currentPage = data.current_page;
  //     //this.unsetSearching();
  //   });
  // }

  getFilteredData(url: string, postData: any, urlParams: string) {
    this.setSearching();
    this._requestService
      .postRequest('/derivative_source_product', postData, urlParams)
      .subscribe((data: any) => {
        //console.log(data);
        this.products = data.data;
        this.products = data.data;
        this.totalProducts = data.total;
        this.perPage = data.per_page;
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;

        this.unsetSearching();
      });
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    console.log(eventData);
    let urlParams = '?page=' + eventData.currentPage;
    this.getFilteredData('/derivative_source_product', '', urlParams);
  }

  setSearching() {
    this.showSearchLoading = true;
  }

  unsetSearching() {
    this.showSearchLoading = false;
  }

  downloadReport() {
    let urlParams = '?is_download=1';

    this._requestService.download(
      '/derivative_source_product',
      '',
      urlParams,
      `derivative_source_product-${new Date().toLocaleString()}`
    );
  }

  searchProduct() {
    this.searchBtnText = 'Searching...';
    this.showSearchLoading = true;
    this.loadProducts(this.createPostData());
  }

  loadProducts(postData: any = [], url: string = DERIVATIVE_SOURCE_PRODUCT) {
    return this.derivativeProduct
      .postRequest(postData, url)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = this.responseData.data;
        this.totalProducts = this.responseData.total;
        this.perPage = this.responseData.per_page;
        this.lastPage = this.responseData.last_page;
        this.currentPage = this.responseData.current_page;
        this.searchBtnText = 'Search';
        this.showSearchLoading = false;
      });
  }

  createPostData() {
    return {
      selectedproductId: this.selectedproductId,
    };
  }
}
